import React from 'react';

import { Close } from '@mui/icons-material';
import { DialogTitle, IconButton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AddProductsDialogHeaderProps {
    onClose: VoidFunction;
}

const AddProductsDialogHeader: React.FC<AddProductsDialogHeaderProps> = ({
    onClose,
}) => {
    const { t } = useTranslation('refund', {
        keyPrefix: 'PRODUCTS_STEP.ADD_PRODUCT_MODAL',
    });

    return (
        <Stack
            justifyContent="space-between"
            flexDirection="row"
            alignItems="center"
            paddingX={1}
        >
            <DialogTitle>{t('TITLE')}</DialogTitle>

            <IconButton onClick={onClose}>
                <Close />
            </IconButton>
        </Stack>
    );
};

export default AddProductsDialogHeader;
